"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyNotPermanent = exports.verifyNotMutable = void 0;

var _enums = require("./enums");

var _utils = require("./utils");

var _cable_ready = require("./cable_ready");

var verifyNotMutable = function verifyNotMutable(detail, fromEl, toEl) {
  // Skip nodes that are equal:
  // https://github.com/patrick-steele-idem/morphdom#can-i-make-morphdom-blaze-through-the-dom-tree-even-faster-yes
  if (!_enums.mutableTags[fromEl.tagName] && fromEl.isEqualNode(toEl)) return false;
  return true;
};

exports.verifyNotMutable = verifyNotMutable;

var verifyNotPermanent = function verifyNotPermanent(detail, fromEl, toEl) {
  var permanentAttributeName = detail.permanentAttributeName;
  if (!permanentAttributeName) return true;
  var permanent = fromEl.closest("[".concat(permanentAttributeName, "]")); // only morph attributes on the active non-permanent text input

  if (!permanent && (0, _utils.isTextInput)(fromEl) && fromEl === _cable_ready.activeElement) {
    var ignore = {
      value: true
    };
    Array.from(toEl.attributes).forEach(function (attribute) {
      if (!ignore[attribute.name]) fromEl.setAttribute(attribute.name, attribute.value);
    });
    return false;
  }

  return !permanent;
};

exports.verifyNotPermanent = verifyNotPermanent;